Revolution.Module.extend({
    NAME: "mde.bk-list-offers", // OBLIGATOIRE (reflète l'arborescence répertoire : /mde/main.js)

    initialize: function ($) {

        $('body').on('click', '.js-accordion', this.toggleAccordion);
    },

    onWindowLoad: function (e) {

    },

    onWindowScroll: function (e) {

    },
    onWindowResize: function (e) {

    },
    toggleAccordion: function (e) {
        var $obj = $(e.currentTarget);
        var $offerWrapper = $obj.next('.accordion-content');

        if ($obj.attr('tabindex') != '-1') {
            $obj.toggleClass('open');
            $offerWrapper.stop().slideToggle();

            if ($obj.hasClass('open')) {
                $obj.attr('aria-expanded', "true");

                if ($obj.closest('.bk-toc').length) {
                    var $bkAccordion = $obj.parent();
                    $bkAccordion.addClass('activated');
                    $bkAccordion.siblings('.bk-accordion').find('.js-accordion').removeClass('open').next('.accordion-content').slideUp();
                    $bkAccordion.siblings('.bk-accordion').removeClass('activated');
                    $bkAccordion.parent().closest('.bk-accordion.activated').removeClass('activated');
                }
            } else {
                $obj.attr('aria-expanded', "false");

                if ($obj.closest('.bk-toc').length) {
                    var $bkAccordion = $obj.parent();
                    $bkAccordion.removeClass('activated');
                    $bkAccordion.find('.bk-accordion').find('.js-accordion').removeClass('open').next('.accordion-content').slideUp();
                    $bkAccordion.find('.bk-accordion').removeClass('activated');
                    if ($bkAccordion.parent().closest('.bk-accordion').find('.open').length) {
                        $bkAccordion.parent().closest('.bk-accordion').addClass('activated');
                    }
                }
            }
        }

    }
});
